// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { URL, URLSearchParams } from "url";
